import { injectIntl } from 'react-intl';

import IncidentsGroupByFilter from './IncidentsGroupByFilter';

export default injectIntl(IncidentsGroupByFilter);
